import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fad7abb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "back-button" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "scan-rectangle" }, [
  /*#__PURE__*/_createElementVNode("svg", null, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      style: {"fill":"transparent","stroke-width":"2","stroke":"rgb(255, 255, 255)"}
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "delete is-large",
        "aria-label": "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      })
    ]),
    _hoisted_2
  ], 64))
}